export default "__VITE_ASSET__Uoh3dNFR__"